<template>
<keep-alive>
  <div class="mobile_registration mobile_registration_content">
  <router-view />
  </div>
</keep-alive>
</template>

<script>
export default {}
</script>
<style lang="scss">
  @import '../../scss/app';

  .test {
    position: absolute;
  }
</style>
